import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import BootstrapVue from "bootstrap-vue";
import Notifications from "vue-notification";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faCheck,
  faTimes,
  faLock,
  faUser,
  faCalendarAlt,
  faFile,
  faFileAlt,
  faHashtag,
  faEuroSign,
  faHeartbeat,
  faChartLine,
  faChartBar,
  faInfoCircle,
  faUmbrella,
  faChartPie,
  faArrowUp,
  faArrowDown,
  faArrowRight,
  faUsers,
  faIdCard,
  faEnvelope,
  faHome,
  faPhone,
  faMobileAlt,
  faSignOutAlt,
  faPiggyBank,
  faFolderOpen,
  faCar,
  faBaby,
  faBriefcase,
  faWallet,
  faFileInvoice,
  faCreditCard,
  faUniversity,
  faMoneyBillWaveAlt,
  faUserPlus,
  faTachometerAlt,
  faQuestionCircle,
  faCalendarDay,
  faCalendarCheck,
  faCalendarTimes,
  faCoins,
  faBackward,
  faForward,
  faSave,
  faFilePdf
} from "@fortawesome/free-solid-svg-icons";
import {
  FontAwesomeIcon,
  FontAwesomeLayers
} from "@fortawesome/vue-fontawesome";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "@/filters/FormatDate";
import "@/filters/FormatNumber";
import Chartkick from "vue-chartkick";

Vue.config.productionTip = false;
Vue.use(BootstrapVue);
Vue.use(Notifications);
Vue.use(Chartkick);

// Include only Font Awesome icons we are actually using
library.add(
  faCheck,
  faTimes,
  faLock,
  faUser,
  faCalendarAlt,
  faFile,
  faFileAlt,
  faHashtag,
  faEuroSign,
  faHeartbeat,
  faChartLine,
  faInfoCircle,
  faUmbrella,
  faChartPie,
  faChartBar,
  faArrowUp,
  faArrowDown,
  faArrowRight,
  faUsers,
  faIdCard,
  faEnvelope,
  faHome,
  faPhone,
  faMobileAlt,
  faSignOutAlt,
  faPiggyBank,
  faFolderOpen,
  faCar,
  faBaby,
  faBriefcase,
  faWallet,
  faFileInvoice,
  faCreditCard,
  faUniversity,
  faMoneyBillWaveAlt,
  faUserPlus,
  faTachometerAlt,
  faQuestionCircle,
  faCalendarDay,
  faCalendarCheck,
  faCalendarTimes,
  faCoins,
  faBackward,
  faForward,
  faSave,
  faFilePdf
);
Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.component("font-awesome-layers", FontAwesomeLayers);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
